import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/internal/NotAllowedCountry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/TranslationsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExternalScripts"] */ "/app/src/modules/client/wrappers/ExternalScripts/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/localization/hooks/useLanguageChange.ts");
